import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fadeUp } from "@/lib/motion";

export default function FinalCTA({
  eyebrow = "Let's begin",
  title = (
    <>
      Let's talk about
      <br />
      <span className="font-display-italic text-[#f26522]">your market.</span>
    </>
  ),
  body =
    "Tell us about your market, organisation and customer relationship — and where the Medicual pathway could fit within the offer.",
  ctaLabel = "Contact us",
  ctaHref = "/contact",
}) {
  return (
    <section
      data-testid="final-cta"
      className="relative bg-[#0a1930] text-[#f4f0e6] overflow-hidden grain"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-44 relative z-10">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <span className="overline-tag text-[#f26522]">{eyebrow}</span>
            <h2 className="font-display text-[clamp(3rem,8vw,8rem)] leading-[0.94] tracking-[-0.03em] mt-6">
              {title}
            </h2>
            <p className="text-lg text-[#f4f0e6]/75 max-w-[520px] mt-8 leading-relaxed">
              {body}
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link
              to={ctaHref}
              data-testid="final-cta-button"
              className="group inline-flex items-center gap-3 bg-[#f26522] text-[#0a1930] px-8 py-5 overline-tag hover:bg-[#f4f0e6] transition-colors"
            >
              {ctaLabel}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </div>
        </motion.div>
      </div>
      <div
        aria-hidden
        className="hidden md:block absolute -bottom-40 right-0 w-[720px] h-[720px] rounded-full bg-[#f26522] opacity-[0.09] blur-[140px]"
      />
    </section>
  );
}
